import axios, { AxiosError } from 'axios';
import { useMutation, UseMutationOptions } from 'react-query';

import { createProfile } from '~/App/Api/Profile';
import { Greet } from '~/types/models';

export const greetsApiPath = '/api/v2/greets';

export interface CreateProfileArgs {
  email: string;
  name: string;
}

export interface CreateGreetArgs {
  assignee_id: string;
  profiles?: string[];
  campaign_id?: string;
  note: string;
}

export interface CreateTaskArgs extends CreateGreetArgs, CreateProfileArgs {}

export interface CreateGreetResponse {
  message?: string;
  data: Greet;
}

export async function createGreet(args: CreateGreetArgs) {
  const res = await axios.post<CreateGreetResponse>(greetsApiPath, args);
  return res.data.data;
}

export async function createTask(args: CreateTaskArgs) {
  const { email, name } = args;

  const profile = await createProfile({ email, name } as CreateProfileArgs);
  const greet = await createGreet({
    ...args,
    profiles: [profile.id],
  } as CreateGreetArgs);

  return greet;
}

export const useCreateTask = (
  options?: UseMutationOptions<Greet, AxiosError, CreateTaskArgs>
) => useMutation(createTask, { ...options });
